import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    number: '1',
    title: 'Agenda Tu Llamada',
    description: 'Habla con nuestro equipo para conocer tu mercado y definir tu estrategia de leads.'
  }, {
    number: '2',
    title: 'Recibe Tus Leads',
    description: 'Te enviamos leads exclusivos y verificados directamente a tu teléfono en tiempo real.'
  }, {
    number: '3',
    title: 'Cierra Más Ventas',
    description: 'Usa nuestro sistema probado y el entrenamiento incluido para convertir leads en clientes.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section id="como-funciona" className="bg-brand-charcoal py-12 md:py-16 px-4 relative" data-id="element-82">
      <div className="max-w-7xl mx-auto" data-id="element-83">
        <div className="text-center mb-10" data-id="element-84">
          <span className="block text-sm font-bold tracking-widest text-brand-orange uppercase mb-4" data-id="element-85">
            Cómo Funciona
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white text-balance" data-id="element-86">
            Empieza a Recibir Leads en 3 Simples Pasos
          </h2>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6 relative" data-id="element-87">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/4 left-[15%] right-[15%] h-0.5 bg-gradient-to-r from-brand-orange/0 via-brand-orange/30 to-brand-orange/0 z-0" data-id="element-88"></div>

          {steps.map((step, index) => <motion.div key={index} variants={cardVariants} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 relative z-10 hover:bg-white/10 transition-colors" data-id="element-89">
              <div className="text-5xl font-extrabold text-brand-orange mb-4 opacity-90" data-id="element-90">
                {step.number}
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-91">
                {step.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-92">
                {step.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}